export const strapiUrlApi = "https://cms.tripmerchant.com/api";
export const strapiUrl = "https://cms.tripmerchant.com";
// export const strapiUrlApi = "http://localhost:1337/api";
// export const strapiUrl = "http://localhost:1337";
export const getData = async (url) => {
  const response = await fetch(`${strapiUrlApi}${url}?populate=deep`);
  const data = await response.json();
  return data;
};
export const getDataFilterUId = async (uid, page = 1) => {
  if (uid) {
    const response = await fetch(
      `${strapiUrlApi}/articles?populate=deep&[filters][categories][uid]=${uid}&pagination[page]=${page}&pagination[pageSize]=8`
    );
    const data = await response.json();
    return data;
  } else {
    const response = await fetch(
      `${strapiUrlApi}/articles?populate=deep&pagination[page]=${page}&pagination[pageSize]=8&sort[0]=blogDate:desc&sort[1]=createdAt:desc`
    );
    const data = await response.json();
    return data;
  }
};

export function expandArrayWithPreviousValues(arr, targetLength) {
  const currentLength = arr.length;

  if (currentLength < targetLength) {
    const expandedArray = [...arr];

    for (let i = currentLength; i < targetLength; i++) {
      expandedArray.push(arr[i % currentLength]);
    }

    return expandedArray;
  }

  return arr;
}

export const getTestimonials = async (url, filter) => {
  const response = await fetch(
    `${strapiUrlApi}${url}?populate=*&[filters][Testimonial]=${filter}`
  );
  const data = await response.json();
  return data;
};
export const createImageUrl = (url) => {
  const imageUrl = `${strapiUrl}${url}`;
  return imageUrl;
};
